export const categories = [
  {
    id: "movie",
    name: "电影",
    description: "精选国语对白剧情长片，涵盖悬疑、爱情、动作等多元题材，感受大银幕叙事张力。",
    cover: "https://readdy.ai/api/search-image?query=cinematic%20film%20theater%20with%20warm%20screen%20glow%20and%20dark%20blue%20ambient%20lighting%2C%20elegant%20moody%20atmosphere%2C%20editorial%20photography&width=800&height=560&seq=gydb-cat-movie&orientation=landscape",
    icon: "ri-film-line",
    count: 128,
  },
  {
    id: "tv",
    name: "电视剧",
    description: "长篇国语剧集资源，都市、家庭、年代题材齐备，适合追剧与连续观看。",
    cover: "https://readdy.ai/api/search-image?query=modern%20living%20room%20television%20glow%20at%20night%2C%20cozy%20blue%20tones%2C%20cinematic%20still%2C%20editorial%20photography&width=800&height=560&seq=gydb-cat-tv&orientation=landscape",
    icon: "ri-tv-2-line",
    count: 96,
  },
  {
    id: "doc",
    name: "纪录片",
    description: "以真实为底色的国语纪实影像，透视人文、自然与时代的细腻切面。",
    cover: "https://readdy.ai/api/search-image?query=majestic%20mountain%20landscape%20at%20dawn%20with%20soft%20mist%2C%20documentary%20aesthetic%2C%20cool%20blue%20tones%2C%20editorial%20photography&width=800&height=560&seq=gydb-cat-doc&orientation=landscape",
    icon: "ri-camera-lens-line",
    count: 74,
  },
  {
    id: "variety",
    name: "综艺",
    description: "轻松有趣的国语综艺节目，访谈、竞技、生活观察，碎片时间也能开怀。",
    cover: "https://readdy.ai/api/search-image?query=vibrant%20stage%20lights%20with%20warm%20orange%20and%20blue%20spotlights%2C%20entertainment%20show%20atmosphere%2C%20editorial%20photography&width=800&height=560&seq=gydb-cat-variety&orientation=landscape",
    icon: "ri-mic-line",
    count: 62,
  },
  {
    id: "anime",
    name: "动漫",
    description: "国漫与配音动画合辑，奇幻、热血、治愈系一网打尽，声画俱佳的国语演绎。",
    cover: "https://readdy.ai/api/search-image?query=artistic%20illustration%20style%20fantasy%20sky%20with%20clouds%20and%20soft%20light%2C%20vivid%20blue%20and%20orange%20gradient%2C%20editorial%20poster&width=800&height=560&seq=gydb-cat-anime&orientation=landscape",
    icon: "ri-magic-line",
    count: 58,
  },
  {
    id: "short",
    name: "微电影",
    description: "短小精悍的国语微电影，一集一个故事，用最短时间触达最真的情绪。",
    cover: "https://readdy.ai/api/search-image?query=moody%20urban%20street%20corner%20at%20dusk%2C%20cinematic%20short%20film%20still%2C%20cool%20tones%20with%20warm%20streetlight%2C%20editorial%20photography&width=800&height=560&seq=gydb-cat-short&orientation=landscape",
    icon: "ri-clapperboard-line",
    count: 45,
  },
];

export const regions = [
  { id: "cn", name: "中国大陆" },
  { id: "hk", name: "中国香港" },
  { id: "tw", name: "中国台湾" },
  { id: "sg", name: "新加坡" },
  { id: "my", name: "马来西亚" },
];

export const genres = [
  { id: "drama", name: "剧情" },
  { id: "suspense", name: "悬疑" },
  { id: "romance", name: "爱情" },
  { id: "comedy", name: "喜剧" },
  { id: "action", name: "动作" },
  { id: "history", name: "历史" },
  { id: "scifi", name: "科幻" },
  { id: "family", name: "家庭" },
  { id: "urban", name: "都市" },
  { id: "wuxia", name: "武侠" },
];

export const years = [
  { id: "2025", name: "2025" },
  { id: "2024", name: "2024" },
  { id: "2023", name: "2023" },
  { id: "2022", name: "2022" },
  { id: "2021", name: "2021" },
  { id: "2020", name: "2020" },
];

export default categories;